import { race, take, put } from 'redux-saga/effects';
import * as t from '../../../../actionTypes.js';

export default function* checkAccessTaskResponse() {
  yield put({ type: t.ACCESS_TASK, payload: { pathname: window.location.pathname } });

  const { success, failure } = yield race({
    success: take(t.ACCESS_TASK_SUCCESS),
    failure: take(t.ACCESS_TASK_FAILED)
  });

  if (failure) {
    // do not block the app if the token is invalid
    console.log('Error in checkAccessTaskResponse', failure.payload);
  }

  if (success) {
    window.location = success.payload.taskUrl;
  }

  return null;
}
